import { getCurrentUser } from '../../core/services';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAuthStore } from '@modules/auth/store';
import { useAuth } from '@modules/auth/hooks';
import { CORE_CURRENT_USER_KEY } from '../constants';
import { User } from '../types';

function useQueryCurrentUser(): UseQueryResult<User> {
  const { isAuthenticated } = useAuth();
  const { login, user } = useAuthStore();

  return useQuery([CORE_CURRENT_USER_KEY], async () => await getCurrentUser(), {
    onSuccess: (userData) => {
      if (user === null) {
        login(userData);
      }
    },
    enabled: isAuthenticated === true,
  });
}

export default useQueryCurrentUser;
